import { applyStyles } from "../utils/applyStyles";
import { animateModal } from "../utils/animateModal";
import { fitContentEvent } from "../context/actions";
var modalMargins = {
    top: 48,
    right: 24,
    bottom: 48,
    left: 24
};
var TRANSITION_DURATION = 300;
export var useModalTransition = function(board, iframeRef) {
    if (!board) {
        return {
            openModalTransition: function() {
                return null;
            },
            closeModalTransition: function() {
                return null;
            }
        };
    }
    var ref = board.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right, width = ref.width, height = ref.height;
    var realRight = right - width;
    var realBottom = window.innerHeight - (top + height);
    var closeModalTransition = function() {
        applyStyles(board, {
            transition: "none",
            position: "absolute",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0"
        });
        fitContentEvent(iframeRef);
    };
    var openModalTransition = function() {
        applyStyles(board, {
            transition: "none",
            position: "fixed",
            top: "".concat(top, "px"),
            right: "".concat(realRight, "px"),
            bottom: "".concat(realBottom, "px"),
            left: "".concat(left, "px")
        });
        animateModal(board, TRANSITION_DURATION, {
            top: top,
            right: realRight,
            bottom: realBottom,
            left: left
        }, modalMargins, function() {
            return fitContentEvent(iframeRef);
        });
    };
    return {
        openModalTransition: openModalTransition,
        closeModalTransition: closeModalTransition
    };
};
